<div class="component-viewer">
    <h1>Edit Sponsor</h1>
    <mat-card *ngIf="canEditSponsor && selectedIteration">
        <mat-card-content>
            <div class="container-fluid">
                <div class="row">
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar><br />
                </div>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
                <div class="container-fluid">
                    <div class="row">
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput required name="name" id="name" placeholder="Name" type="text"
                                formControlName="name" />
                            <mat-error *ngIf="form.get('name').errors?.required">Name is required</mat-error>
                            <mat-error *ngIf="form.get('name').errors?.validationErrors">
                                {{ form.get("name").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field>
                            <mat-label>Contact Email</mat-label>
                            <input matInput required name="contactEmail" id="contactEmail" placeholder="Contact Email"
                                type="email" formControlName="contactEmail" />
                            <mat-error *ngIf="form.get('contactEmail').errors?.required">Contact Email is
                                required</mat-error>
                            <mat-error *ngIf="form.get('contactEmail').errors?.validationErrors">
                                {{ form.get("contactEmail").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field>
                            <mat-label>Company</mat-label>
                            <input matInput name="company" id="company" placeholder="Company" type="text"
                                formControlName="company" />
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field>
                            <mat-label>Sponsor Type</mat-label>
                            <mat-select name="type" formControlName="type" placeholder="Sponsor Type">
                                <mat-option *ngFor="let type of keys()"
                                    [value]="parseEnumKey(type)">{{parseEnumValue(type)}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field class="margin-right">
                            <mat-label>Request Recepit</mat-label>
                            <mat-select name="requestReceipt" formControlName="requestReceipt"
                                placeholder="Request Receipt">
                                <mat-option [value]="true">Yes</mat-option>
                                <mat-option [value]="false">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field>
                            <mat-label>Amount</mat-label>
                            <input matInput name="amount" id="amount" placeholder="Amount" type="number"
                                formControlName="amount" />
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field>
                            <mat-label>Notes</mat-label>
                            <textarea matInput name="notes" id="notes" placeholder="Notes" type="text"
                                formControlName="notes" rows="5"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1">
                        <button mat-raised-button>Save</button>
                    </div>
                    <div class="col-1">
                        <button mat-raised-button class="warning" [routerLink]="['../../../sponsors']">Cancel</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="!canEditSponsor">
        <mat-card-content>
            <div class="mat-h3">Sorry, unable to create a sponsor for the selected outing and date. Please select a
                different outing or date</div>
        </mat-card-content>
    </mat-card>
</div>